import ModifyTouchDefault, * as ModifyTouchNS from './../../node_modules/ol-ext/interaction/ModifyTouch.js';

// side-effect patch (DO NOT REMOVE)
import Modify from './Modify.js';

// Wrapper class extends the default ModifyTouch
class ModifyTouch extends ModifyTouchDefault {
    constructor(options) {

        super(options);

        this.insertVertexCondition_ = function () {
            return true;
        }

        this.showDeleteBt = function (e) {
            if (!this._popup) 
                return;
            
            var isPoint = false;

            if(e.feature) {
                var geom = e.feature.getGeometry();
                isPoint = geom.getType() === 'Point';
            }

            if (this.get('usePopup') && e.type === 'show' && isPoint == false) {
                this
                    ._popup
                    .show(e.coordinate, this._menu);
            } else {
                this
                    ._popup
                    .hide();
            }
            e.type += 'popup';
            this.dispatchEvent(e);
            // Date if popup start a timeout to prevent touch + click on the popup
            this._timeout = new Date();
        }
    }
}

// Attach named exports to the class as static methods
Object
    .entries(ModifyTouchNS)
    .forEach(([key, value]) => {
        if (key !== "default") {
            ModifyTouch[key] = value;
        }
    });

export default ModifyTouch;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol-ext/interaction/ModifyTouch.js';